import { css } from '@compiled/react';

import {
	AppSwitcher,
	AtlassianNavigation,
	Help,
	Notifications,
	ProductHome,
	Profile,
	Search,
	Settings,
} from '@atlaskit/atlassian-navigation';
import Avatar from '@atlaskit/avatar';
import { JiraIcon, JiraLogo } from '@atlaskit/logo';

const AtlassianProductHome = () => <ProductHome icon={JiraIcon} logo={JiraLogo} />;

const greyLine = css({
	height: '4px',
	borderRadius: '1.362px',
	background: 'var(--neutral-light-alpha-n-40-a, rgba(9, 30, 66, 0.13))',
	width: '75px',
	marginInlineEnd: '8px',
	marginInlineStart: '8px',
});

const lineContainer = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

const lineContainerWithBlueBackground = css({
	padding: '10px',
});

const blueBackground = css({
	borderRadius: '1.362px',
	background: 'var(--Blue-B75, #B3D4FF)',
	height: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

const overlay = css({
	pointerEvents: 'none',
});

const fakeProfile = () => (
	<Profile
		icon={<Avatar size="small" />}
		onClick={() => null}
		tooltip="Your profile and settings"
	/>
);

const fakeSearch = () => {
	return (
		<Search
			onClick={() => null}
			placeholder="Search..."
			tooltip="Search"
			label="Search"
			value={''}
		/>
	);
};

const fakeSettings = () => <Settings tooltip="Product settings" />;

const fakeNotifications = () => <Notifications badge={() => null} tooltip="Notifications" />;

const fakeAppSwitcher = () => <AppSwitcher tooltip="Switch between apps" />;

const fakeHelp = () => <Help tooltip="Get help" />;

export const BoardHeader = () => {
	return (
		<div css={overlay}>
			<AtlassianNavigation
				label="site"
				renderProductHome={AtlassianProductHome}
				primaryItems={[
					<div key="fake1" css={lineContainer}>
						<div css={greyLine} />
					</div>,
					<div key="fake2" css={lineContainer}>
						<div css={greyLine} />
					</div>,
					<div key="fake3" css={lineContainer}>
						<div css={greyLine} />
					</div>,
					<div key="fake4" css={[lineContainer, lineContainerWithBlueBackground]}>
						<div css={blueBackground}>
							<div css={greyLine} />
						</div>
					</div>,
				]}
				renderSearch={fakeSearch}
				renderProfile={fakeProfile}
				renderSettings={fakeSettings}
				renderNotifications={fakeNotifications}
				renderAppSwitcher={fakeAppSwitcher}
				renderHelp={fakeHelp}
			/>
		</div>
	);
};
